export const ResendReleasePaymentHoldConstant = {
    CATEGORY: "Support",
    TITLE: "nGen Release",
    ACTION_CODE: "Action Code",
    DOC_NO: "Doc No.",
    CONTAINER_NO: "Container No.",
    DOC_DATE: "Doc Date",
    DOC_DATE_RANGE: "Doc Date Range",
    HOLD_CONDITION: "Hold Condition",
    STATUS: "Status",
    RETURN_MESSAGE: "Return Msg",
    RESEND_BUT: "Resend",
    BL_NO: "BL No.",
    CRO_NO: "Cro No.",
    ESN_NO: "Esn No.",
    INVOICE_NO: "Invoice No.",
    EXP_BOOKING_NO: "Exp Booking No.",
    BOOKING_REQ_SEQ_NO: "Booking Req Seq No.",
    ESN_QTY: "Esn Qty",
    AGENT_CODE: "Agent Code",
    COLLECTION_DATE: "Collection Date",
    PRINTER_URL: "Printer URL",
    ESN_PIN_NO: "Esn Pin No.",
    AGENT_DELIVERY_DATE: "Agent Delivery Date",
    USER_ID: "Cashier ID",
}
